export default __webpack_public_path__ + "static/finalist-eta-e680c7bc1bd1debd5e0809a480738457.png";